import { useNavigate } from "react-router-dom";
import {
  Users, Dumbbell, Folder, CheckCircle, ChevronRight,
} from "lucide-react";

export default function DashboardTab({ companyInfo, token, bc }) {
  const navigate = useNavigate();
  const primary = bc?.primary || "#C9A84C";
  const stats = [
    { label: "Sporters", val: companyInfo?.sporter_count ?? 0, icon: <Users size={20} />, color: primary },
    { label: "Schema's", val: companyInfo?.schema_count ?? 0, icon: <Dumbbell size={20} />, color: "#3b82f6" },
    { label: "Mappen", val: companyInfo?.folder_count ?? 0, icon: <Folder size={20} />, color: "#10b981" },
    { label: "Admins", val: companyInfo?.admin_count ?? 0, icon: <CheckCircle size={20} />, color: "#8b5cf6" },
  ];

  const cardStyle = bc ? {
    background: bc.card,
    borderColor: bc.border,
    color: bc.text,
  } : {};

  return (
    <div>
      <div className="mb-6">
        <p className="text-xs font-bold uppercase tracking-widest mb-1" style={{ color: primary }}>Overzicht</p>
        <h2 className="text-xl font-bold text-white">{companyInfo?.naam || "Mijn Bedrijf"}</h2>
        {companyInfo?.slug && <p className="text-zinc-500 text-sm mt-0.5">/{companyInfo.slug}</p>}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
        {stats.map(({ label, val, icon, color }) => (
          <div key={label} className="bg-[#0f0f0f] border border-white/5 rounded-2xl p-5"
            style={cardStyle}>
            <div className="mb-3" style={{ color }}>{icon}</div>
            <div className="text-3xl font-black" style={{ color: bc?.text || "#fff" }}>{val}</div>
            <div className="text-zinc-500 text-xs mt-1">{label}</div>
          </div>
        ))}
      </div>

      {/* Start Workout knop */}
      <div className="mb-6">
        <button
          data-testid="groep-modus-link"
          onClick={() => navigate("/groep")}
          className="w-full bg-[#0f0f0f] border border-white/5 rounded-2xl p-5 text-left hover:opacity-80 transition-all group"
          style={{ ...cardStyle, borderColor: (bc?.primary || "#C9A84C") + "33" }}>
          <div className="w-10 h-10 rounded-xl mb-3 flex items-center justify-center" style={{ background: (bc?.primary || "#C9A84C") + "20" }}>
            <Users size={20} style={{ color: bc?.primary || "#C9A84C" }} />
          </div>
          <p className="font-bold text-sm" style={{ color: bc?.text || "#fff" }}>Start Workout</p>
          <p className="text-zinc-600 text-xs mt-1">Selecteer een sporter en start direct met trainen</p>
        </button>
      </div>

      {/* Branding preview */}
      {companyInfo?.branding && (
        <div className="bg-[#0f0f0f] border border-white/5 rounded-2xl p-5 mb-6"
          style={cardStyle}>
          <p className="text-zinc-400 text-xs font-semibold uppercase tracking-wide mb-3">Jouw whitelabel branding</p>
          <div className="flex items-center gap-3 flex-wrap">
            {companyInfo.branding.logo_url && (
              <img src={companyInfo.branding.logo_url} alt="Logo" className="w-10 h-10 rounded-xl object-cover border border-white/10"
                style={{ borderColor: bc?.border }} />
            )}
            {[
              { key: "primary_color",  label: "Knop"         },
              { key: "bg_color",       label: "Achtergrond"  },
              { key: "nav_color",      label: "Navigatie"    },
              { key: "card_color",     label: "Kaart"        },
              { key: "card2_color",    label: "Input"        },
              { key: "border_color",   label: "Rand"         },
              { key: "text_color",     label: "Tekst"        },
            ].map(({ key, label }) =>
              companyInfo.branding[key] ? (
                <div key={key} className="flex items-center gap-1.5">
                  <div className="w-5 h-5 rounded-full border border-white/15 shadow-sm" style={{ background: companyInfo.branding[key], borderColor: bc?.border }} />
                  <span className="text-zinc-500 text-xs">{label}</span>
                </div>
              ) : null
            )}
          </div>
        </div>
      )}

      <div className="bg-[#0f0f0f] border border-white/5 rounded-2xl p-5"
        style={{ ...cardStyle, borderColor: (bc?.primary || "#C9A84C") + "33" }}>
        <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{ color: bc?.primary || "#C9A84C" }}>Snel starten</p>
        <ul className="space-y-2 text-sm text-zinc-400">
          <li className="flex items-center gap-2"><ChevronRight size={14} style={{ color: bc?.primary || "#C9A84C" }} /> Ga naar <strong style={{ color: bc?.text || "#fff" }}>Sporters</strong> om je eerste klanten toe te voegen</li>
          <li className="flex items-center gap-2"><ChevronRight size={14} style={{ color: bc?.primary || "#C9A84C" }} /> Maak <strong style={{ color: bc?.text || "#fff" }}>Mappen</strong> aan om schema's te organiseren (bijv. Beginners, Gevorderden)</li>
          <li className="flex items-center gap-2"><ChevronRight size={14} style={{ color: bc?.primary || "#C9A84C" }} /> Voeg <strong style={{ color: bc?.text || "#fff" }}>Schema's</strong> toe en wijs ze toe aan sporters</li>
          <li className="flex items-center gap-2"><ChevronRight size={14} style={{ color: bc?.primary || "#C9A84C" }} /> Stel je <strong style={{ color: bc?.text || "#fff" }}>Branding</strong> in via Instellingen voor een eigen look &amp; feel</li>
        </ul>
      </div>
    </div>
  );
}
